export default class Image {
  id?: string;
  imageURL?: string;

  constructor(response?: any) {
    if (response != null) {
      this.id = response.id;
      this.imageURL = response.originalSrc;
    }
  }
}
